<template lang="pug">
    v-stepper.elevation-1( v-model='step' )
        v-stepper-header.elevation-0
            v-stepper-step( :complete='step > 1' step='1' ) General
            v-divider
            v-stepper-step( :complete='step > 2' step='2' ) Comercial
            v-divider
            v-stepper-step( :complete='step > 3' step='3' ) Inventario
            v-divider
            v-stepper-step( :complete='step > 4' step='4' ) Productos
        v-stepper-items
            v-stepper-content( step='1' )
                crud-form( ref='formGeneral' submit-text='siguiente' v-bind='formGeneralProps' @submitForm='submitFormGeneral' @calculate='calculateFormGeneral' )
                    template( slot='prependButton' )
                        v-btn.mt-3.mr-3.subheading( block color='info' outline @click='submitGenerateInternalCode' ) generar código interno
            v-stepper-content( step='2' )
                crud-form( ref='formComercial' submit-text='siguiente' v-bind='formComercialProps' @reset='resetFormComercial' @submitForm='submitFormComercial' )
                    template( slot='prependContent' )
                        crud-data-table.table-append( checkable no-actions no-auto-width no-search-box no-visual-help no-export ref='tableComercial' show-all v-bind='tableComercialProps' @change-item='calculateTableComercial' )
                    template( slot='prependButton' )
                        v-btn.mt-3.mr-3.subheading( block color='info' @click='step--' ) anterior
                        //v-btn.mt-3.mr-3.subheading( block color='info' outline ) agregar sucursal
            v-stepper-content( step='3' )
                crud-form( ref='formInventory' submit-text='siguiente' v-bind='formInventoryProps' @reset='resetFormInventory' @submitForm='submitFormInventory' )
                    template( slot='prependContent' )
                        crud-data-table.table-append( checkable no-actions no-auto-width no-search-box no-visual-help no-export ref='tableInventory' show-all v-bind='tableInventoryProps' )
                    template( slot='prependButton' )
                        v-btn.mt-3.mr-3.subheading( block color='info' @click='step--' ) anterior
            v-stepper-content( step='4' )
                crud-form( submit-text='crear promoción' @submitForm='submitForm' )
                    template( slot='appendContent' )
                        crud-data-table.table-append( checkable no-actions no-auto-width no-search-box no-visual-help no-export ref='tableProducts' show-all v-bind='tableProductsProps' )
                        v-alert(:value="showAlertNotSelected" type="info") Sin productos seleccionados (Haga click en agregar productos)
                    template( slot='prependButton' )
                        v-btn.mt-3.mr-3.subheading( block color='info' @click='step--' ) anterior
                        v-btn.mt-3.mr-3.subheading( block color='info' outline @click='dialog = true' ) agregar productos
        v-dialog( content-class='white' fullscreen transition='dialog-bottom-transition' v-model='dialog' )
            v-toolbar( color='primary' dark flat )
                v-btn( icon @click='dialog = false' )
                    v-icon close
                v-toolbar-title Seleccionar productos
                v-spacer
                v-btn( color='accent' depressed @click='submitDialog' ) confirmar
                    v-icon.ml-2 done_all
            model-data-table(
                ref="dialogTableProducts"
                v-bind="dialogTableProductsProps"
                checkable
                editable
                no-actions
                :defaultLimit="100"
                )
</template>

<script>
//
import { mapActions } from 'vuex'
//
import { ModelDataTable } from '@/components/reusable_components/next'
import { CrudDataTable, CrudForm } from '@/components/reusable_components'
//
import BranchOfficeService from '@/services/api/branchOffice'
import FamilyService from '@/services/api/family/FamilyServices'
import MeasurementUnitService from '@/services/api/unitMeasurement/UnitMeasurementService'
import ProductService from '@/services/api/product'
import SubFamilyService from '@/services/api/subfamily/SubfamilyService'
import TagService from '@/services/api/tag/TagServices'
import PromoService from '@/services/api/promo'
import ProviderService from '@/services/api/provider'
import WarehouseService from '@/services/api/warehouse'
import SaleUtils from '@/services/SaleUtils'
import MdlProduct from '../../models/Warehouse/WhProduct'
//
import GeneralFields from './partials/fields/general'
import ComercialFields from './partials/fields/comercial'
import InventoryFields from './partials/fields/inventory'
//
import ComercialHeaders from './partials/headers/comercial'
import InventoryHeaders from './partials/headers/inventory'
import ProductsHeaders from './partials/headers/products'
import DialogProductsHeaders from './partials/headers/dialogProducts'
//
import DialogProductsFilters from './partials/filters/list'
//
export default {
    name: 'promo-create',
    components: {
        'crud-form': CrudForm,
        'crud-data-table': CrudDataTable,
        'model-data-table': ModelDataTable,
    },
    computed: {
        /**
         *
         */
        currentBranchOfficeId() {
            return this.currentUser
                ? this.currentUser.hr_employee.g_branch_office
                : 1
        },

        /**
         *
         */
        currentUser() {
            return this.$store.state.AuthModule.user
        },

        /**
         *
         */
        dialogTableProductsProps() {
            return {
                filters: this.dialogTableProductsFilters,
                headers: this.dialogTableProductsHeaders,
                service: MdlProduct,
            }
        },

        /**
         *
         */
        formComercialProps() {
            return {
                fields: this.formComercialFields,
            }
        },

        /**
         *
         */
        formGeneralProps() {
            return {
                fields: this.formGeneralFields,
            }
        },

        /**
         *
         */
        formInventoryProps() {
            return {
                fields: this.formInventoryFields,
            }
        },

        /**
         *
         */
        tableComercialProps() {
            return {
                filters: [],
                headers: ComercialHeaders,
                service: this.tableComercialService,
            }
        },

        /**
         *
         */
        tableInventoryProps() {
            return {
                filters: [],
                headers: InventoryHeaders,
                service: this.tableInventoryService,
            }
        },

        /**
         *
         */
        tableProductsProps() {
            return {
                filters: [],
                headers: ProductsHeaders,
                service: this.tableProductsService,
            }
        },
    },
    data() {
        return {
            dialog: false,
            dialogTableProductsFilters: DialogProductsFilters.slice(),
            dialogTableProductsHeaders: DialogProductsHeaders.slice(),
            formComercialFields: ComercialFields,
            formGeneralFields: GeneralFields,
            formInventoryFields: InventoryFields,
            step: 1,
            tableComercialItems: [],
            tableComercialService: {},
            tableInventoryItems: [],
            tableInventoryService: {},
            tableProductsItems: [],
            tableProductsService: {},
            showAlertNotSelected: true,
        }
    },
    methods: {
        /**
         *
         */
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),

        /**
         *
         */
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),

        /**
         *
         */
        async calculateFormGeneral({ field, value, vmodels }) {
            //
            switch (field) {
                case 'wh_family_id':
                    this.formGeneralFields[3].options.data = await SubFamilyService.fetchAllSubfamilyByFamilyId(
                        value
                    )
                    break
            }

            //
            // this.formGeneralFields = [...this.formGeneralFields]
        },

        /**
         *
         */
        async calculateTableComercial({ idx, item, jdx }) {
            //
            switch (jdx) {
                case 1:
                case 2:
                    item.gains_margin = SaleUtils.getMargin(
                        item.sale_price,
                        item.cost_price
                    )
                    break
            }

            //
            //this.resetTableComercialService()
        },

        /**
         *
         */
        calculateProducts: async function(e) {
            //this.setProductsFieldOptionData( 0, await ProductService.fetchBySearch(e) )
        },

        /**
         *
         */
        computedCostPrice(item) {
            //
            const branch_office = item.branch_offices.find(
                this.findBranchOffice
            )
            //
            return branch_office ? branch_office.cost_price : 0
        },

        /**
         *
         */
        computedCriticalStock(item) {
            //
            const branch_office = item.branch_offices.find(
                this.findBranchOffice
            )
            //
            return branch_office ? branch_office.critical_stock : 0
        },

        /**
         *
         */
        computedGainMargin(item) {
            //
            const branch_office = item.branch_offices.find(
                    this.findBranchOffice
                ),
                sale_price = item.sale_prices.find(this.findSalePrice)
            //
            return branch_office && sale_price
                ? SaleUtils.getMargin(
                      sale_price.sale_price,
                      branch_office.cost_price
                  ) + ' %'
                : 0
        },

        /**
         *
         */
        computedSalePrice(item) {
            //
            const sale_price = item.sale_prices.find(this.findSalePrice)
            //
            return sale_price ? sale_price.sale_price : 0
        },

        /**
         *
         */
        findBranchOffice(branch_office) {
            return (
                this.currentBranchOfficeId === branch_office.g_branch_office_id
            )
        },

        /**
         *
         */
        findSalePrice(sale_price) {
            return this.currentBranchOfficeId === sale_price.branch_office_id
        },

        /**
         *
         */
        getPromoRequestData() {
            //
            const generalData = this.$refs.formGeneral.vmodels,
                comercialData = this.$refs.formComercial.vmodels,
                inventoryData = this.$refs.formInventory.vmodels

            //
            return {
                ...generalData,
                ...comercialData,
                ...inventoryData,
                branch_office_data: this.tableInventoryItems
                    .reduce(this.reduceBranchOffice, this.tableComercialItems)
                    .map(this.mapBranchOffice),
                products: [...this.tableProductsItems.map(this.mapProducts)],
                create_promo: true,
            }
        },

        /**
         *
         */
        mapBranchOffice(branch_office) {
            return {
                g_branch_office_id: branch_office.id,
                cost_price: branch_office.cost_price,
                sale_price: branch_office.sale_price,
                gains_margin: branch_office.gains_margin,
                maximum_stock: branch_office.maximum_stock,
                minimum_stock: branch_office.minimum_stock,
                critical_stock: branch_office.critical_stock,
            }
        },

        /**
         *
         */
        mapBranchOfficeToComercialItem(branchOffice) {
            return {
                ...branchOffice,
                cost_price: 0,
                sale_price: 0,
                gains_margin: 0,
            }
        },

        /**
         *
         */
        mapBranchOfficeToInventoryItem(branchOffice) {
            return {
                ...branchOffice,
                minimum_stock: 0,
                maximum_stock: 0,
                critical_stock: 0,
            }
        },

        /**
         *
         */
        mapProducts(product) {
            return {
                quantity: product.quantity,
                wh_product_id: product.wh_product_id,
            }
        },

        /**
         *
         */
        mapSelectedToProductsItem(selected) {
            return {
                ...selected,
                quantity: 0,
                wh_product_id: selected.id,
            }
        },

        /**
         *
         */
        parseErrors(errors) {
            //
            var message = Object.values(errors || {}).reduce(
                (total, curr) => total + ' ' + curr.join(', '),
                ''
            )

            //
            message = message.replace(
                'El campo family id',
                'El nombre de familia'
            )
            message = message.replace(
                'El campo subfamily id',
                'El nombre de subfamilia'
            )
            message = message.replace(
                'El campo product name',
                'El nombre del producto'
            )
            message = message.replace('El campo products.', 'En el producto (')
            message = message.replace('.quantity', '), la cantidad')

            //
            return message
        },

        /**
         *
         */
        async rebuild() {
            //
            this.dialogTableProductsFilters[0].options = await ProviderService.fetchAll()
            this.dialogTableProductsFilters[1].options = await WarehouseService.fetchAll()
            this.dialogTableProductsFilters[3].options = await FamilyService.fetchAll()
            this.dialogTableProductsFilters[4].options = await SubFamilyService.fetchAll()
            this.dialogTableProductsFilters[5].options = await TagService.fetchAll()

            //
            this.dialogTableProductsHeaders[4][
                'computed'
            ] = this.computedCriticalStock
            this.dialogTableProductsHeaders[5][
                'computed'
            ] = this.computedCostPrice
            this.dialogTableProductsHeaders[6][
                'computed'
            ] = this.computedSalePrice
            this.dialogTableProductsHeaders[7][
                'computed'
            ] = this.computedGainMargin

            //
            this.formGeneralFields[4].options.data = this.dialogTableProductsFilters[5].options
            this.formGeneralFields[2].options.data = this.dialogTableProductsFilters[3].options
            //this.formGeneralFields[3].options.data = this.dialogTableProductsFilters[4].options

            //
            this.formInventoryFields[1].options.data = await MeasurementUnitService.fetchAll()

            //
        },

        /**
         *
         */
        reduceBranchOffice(total, curr, idx) {
            //
            total[idx].minimum_stock = curr.minimum_stock
            total[idx].maximum_stock = curr.maximum_stock
            total[idx].critical_stock = curr.critical_stock

            //
            return total
        },

        /**
         *
         */
        async reset() {
            //
            const branchOffices = await BranchOfficeService.fetchAll()

            //
            this.tableComercialItems = branchOffices.map(
                this.mapBranchOfficeToComercialItem
            )
            this.tableInventoryItems = branchOffices.map(
                this.mapBranchOfficeToInventoryItem
            )

            //
            this.resetTableComercialService()
            this.resetTableInventoryService()
            this.resetTableProductsService()
        },

        /**
         *
         */
        resetFormComercial() {
            //
            this.tableComercialItems = this.tableComercialItems.map(
                this.mapBranchOfficeToComercialItem
            )
            this.resetTableComercialService()

            //
            this.$refs.tableComercial.checkAll()
            this.$refs.tableComercial.checkAll()
        },

        /**
         *
         */
        resetFormInventory() {
            //
            this.tableInventoryItems = this.tableInventoryItems.map(
                this.mapBranchOfficeToInventoryItem
            )
            this.resetTableInventoryService()

            //
            this.$refs.tableInventory.checkAll()
            this.$refs.tableInventory.checkAll()
        },

        /**
         *
         */
        resetTableComercialService() {
            this.tableComercialService = {
                dtFetchData: () => ({
                    data: this.tableComercialItems,
                }),
            }
        },

        /**
         *
         */
        resetTableInventoryService() {
            this.tableInventoryService = {
                dtFetchData: () => ({
                    data: this.tableInventoryItems,
                }),
            }
        },

        /**
         *
         */
        resetTableProductsService() {
            this.tableProductsService = {
                dtFetchData: () => ({
                    data: this.tableProductsItems,
                }),
            }
        },

        /**
         *
         */
        async responseForm(response) {
            switch (response.status) {
                case 'success':
                    return this.showSnackbar(
                        'success',
                        'Exito.',
                        'La promocion fue creada exitosamente.',
                        this.refresh
                    )
                case 'error':
                    return this.showSnackbar(
                        'error',
                        'Error.',
                        this.generateErrorMessage(response)
                    )
            }
        },

        /**
         *
         */
        async showSnackbar(type, title, message) {
            this.initSnackbar(this.fillSnack(type, title, message, false, 3000))
        },

        /**
         *
         */
        submitDialog() {
            //
            this.tableProductsItems = this.$refs.dialogTableProducts.selected.map(
                this.mapSelectedToProductsItem
            )
            this.resetTableProductsService()

            //
            this.dialog = false
        },

        /**
         *
         */
        async submitGenerateInternalCode() {
            //
            const {
                error,
                errors,
                message,
                status,
                suggested_code,
            } = await PromoService.fetchSuggestInternalCode(
                this.$refs.formGeneral.vmodels
            )

            //
            switch (status) {
                case 'success':
                    this.resetSnackbarState()
                    this.$refs.formGeneral.vmodels.internal_code = suggested_code
                    this.showSnackbar(
                        'info',
                        'Modificado.',
                        'Se modifico el campo de código interno'
                    )
                    break
                case 'error':
                    this.resetSnackbarState()
                    this.showSnackbar(
                        'error',
                        'Error.',
                        errors ? this.parseErrors(errors) : error || message
                    )
                    break
            }
        },

        /**
         *
         */
        submitFormGeneral(data) {
            this.step++
        },

        /**
         *
         */
        submitFormComercial(data) {
            this.step++
        },

        /**
         *
         */
        submitFormInventory(data) {
            this.step++
        },

        /**
         *
         */
        async submitForm(data) {
            //
            if (this.tableProductsItems.length < 1) {
                //
                return this.showSnackbar(
                    'error',
                    'Error.',
                    'Se necesita de al menos un producto.'
                )
            }
            //
            const {
                error,
                errors,
                message,
                status,
            } = await PromoService.create(this.getPromoRequestData())
            //
            switch (status) {
                case 'error':
                    this.resetSnackbarState()
                    this.showSnackbar(
                        'error',
                        'Error.',
                        errors ? this.parseErrors(errors) : error || message
                    )
                    break
                case 'success':
                    this.resetSnackbarState()
                    this.showSnackbar(
                        'success',
                        'Éxito.',
                        'Promoción agregada.'
                    )
                    this.$router.push({ name: 'promos_list' })
                    break
            }
        },
    },
    mounted() {
        this.rebuild()
        this.reset()
        this.$refs.formGeneral.resetForm()
        this.$refs.formComercial.resetForm()
        this.$refs.formInventory.resetForm()
        this.setTitleTopBar('Crear promoción')
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('CREATE_PRODUCT_PROMO')) ctx.$router.push('/')
        })
    },
    watch: {
        dialog(val) {
            if (val === true) {
                //alert('hola')
                this.showAlertNotSelected = false
                // this.$refs.dialogTableProducts.fetchData()
                // console.log(this.$refs.dialogTableProducts.items,'itemss')
                // if(this.$refs.dialogTableProducts.items.length==0){
                //     alert('akidialog')
                //     this.$refs.dialogTableProducts.fetchData()
                // }
            }
        },
    },
}
</script>

<style>
.table-append {
    padding: 0 3rem;
}
.table-append .table-container {
    width: 100% !important;
}
.table-append .table-container .body-rows {
    width: auto !important;
}
</style>
